import { useEffect } from "react";
import { handlers, useBoardContext } from "@rastreabilidadebrasil/tageditor";

const GlobalHandlers = () => {
  const { board, boardHandlers, boardZoom } = useBoardContext();

  useEffect(() => {
    if (board && boardHandlers && boardZoom) {
      boardHandlers.add(handlers.createAligninGuidelineHandler(board, boardZoom));
      boardHandlers.add(handlers.createCenteringGuidelineHandler(board, boardZoom));
      //boardHandlers.add(handlers.createZoomWhellHandler(boardZoom));
      boardHandlers.add(handlers.createZoomWorkspaceWheelHandler(board, boardZoom));
      boardHandlers.add(handlers.createArrowMoveHandler(board));
    }
  }, [board, boardHandlers, boardZoom]);

  return null;
};

export default GlobalHandlers;
